import { type SpinResponse } from '../../../entities/wheel/model/wheel.types';
import { api } from '../api';

export const spin = async (): Promise<SpinResponse | undefined> => {
  const res = await api.post('v3/wheel/spin');
  return res.data;
};

export const spinX = async (): Promise<SpinResponse | undefined> => {
  const res = await api.post('v3/wheel/spin/x');
  return res.data;
};
